import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './component/home/home.component';
import { LoginComponent } from './component/login/login.component';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SidebarMenuComponent } from './component/common/sidebar-menu/sidebar-menu.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTreeModule } from '@angular/material/tree';
import { PortafolioComponent } from './component/portafolio/portafolio.component';
import { MatDividerModule } from '@angular/material/divider';
import { DragScrollComponent, DragScrollItemDirective } from 'ngx-drag-scroll';
import { CarnetComponent } from './component/carnet/carnet.component';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatOptionModule } from '@angular/material/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MaincontainerComponent } from './component/maincontainer/maincontainer.component';
import { ForgetPasswordComponent } from './component/forget-password/forget-password.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GenericDialogComponent } from './component/common/dialogs/generic.dialog/generic.dialog.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SessionStorageService } from './services/security/session-storage.service';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogGenericFrame } from './component/common/dialogs/dialog-generic-frame/dialog-generic-frame.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SafeUrlPipe } from './utils/safe-url.pipe';
import { DialogCarnetSendComponent } from './component/common/dialogs/dialog-carnet-send/dialog-carnet-send.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatGridListModule } from '@angular/material/grid-list';
import { CotizadorComponent } from './component/cotizador/cotizador.component';
import { DialogBeneficiaryComponent } from './component/common/dialogs/dialog-beneficiary/dialog-beneficiary.component';
import { DialogContratComponent } from './component/common/dialogs/dialog-contrat/dialog-contrat.component';
import { DialogColectivoComponent } from './component/common/dialogs/dialog-colectivo/dialog-colectivo.component';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { CustomDateAdapter } from './utils/custom-date-adapter';
import { MY_DATE_FORMATS } from './utils/date-format';

//modulos cotizadores
import { MatTabsModule } from '@angular/material/tabs';
import { SnackBarService } from './utils/util.SnackBarService';
import { MatNativeDateModule, MatOption } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomPaginator } from './shared/config/custom-paginator-intl';
import { MatSortModule } from '@angular/material/sort';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ModalAlert } from './component/common/dialogs/modal.alert/modal.alert.component';
import { MisCotizacionesComponent } from './component/misCotizaciones/mis-cotizaciones.component';
import { MiCotizacionComponent } from './component/miCotizacion/mi-cotizacion.component';
import { PoblacionComponent } from './component/poblacion/poblacion.component';
import { CotizacionMultipleComponent } from './component/cotizacion-multiple/cotizacion-multiple.component';
import { DialogPoblacionDetalleComponent } from './component/common/dialogs/dialog-poblacion-detalle/dialog-poblacion-detalle.component';
import { DialogPoblacionGenerarComponent } from './component/common/dialogs/dialog-poblacion-generar/dialog-poblacion-generar.component';
import { ConsultaPoblacionComponent } from './component/consultaPoblacion/consultaPoblacion.component';
import { DialogPoblacionDetalleAnexosComponent } from './component/common/dialogs/dialog-poblacion-detalle-anexos/dialog-poblacion-detalle-anexos.component';
import { QuillModule } from 'ngx-quill';
import { ComisionesComponent } from './component/comisiones/comisiones.component';
import { IframeGenericComponent } from './component/common/iframe-generic/iframe-generic.component';
import { FormularioSolicitudComponent } from './component/formulario-solicitud/formulario-solicitud.component';
import { AfiliacionesComponent } from './component/afiliaciones/afiliaciones.component';
import { OportunidadesComercialesInternosComponent } from './component/oportunidades-comerciales-internos/oportunidades-comerciales-internos.component';
import { DialogOportunidadesComponent } from './component/common/dialogs/dialog-oportunidades/dialog-oportunidades.component';
import { MisOportunidadesComercialesAsesorExternoComponent } from './component/mis-oportunidades-comerciales-acesor-externo/mis-oportunidades-comerciales-acesor-externo.component';
import { OportunidadesRedirectComponent } from './component/oportunidades-redirect/oportunidades-redirect.component';
import { AppTrackDirective } from './component/app-track/app-track.directive';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TrackingInterceptor } from './component/interceptors/tracking.interceptor';
import { DialogOporunidadesExternosComponent } from './component/common/dialogs/dialog-oporunidades-externos/dialog-oporunidades-externos.component';
import { DetalleDialogComponent } from './component/common/dialogs/detalle-dialog/detalle-dialog.component';
import { GestionReferidosComponent } from './component/common/dialogs/gestion-referidos/gestion-referidos.component';
import { MisReferidosComponent } from './component/mis-referidos/mis-referidos.component';
import { AutorizacionesComponent } from './component/autorizaciones/autorizaciones.component';
import { ModalNotificacionComisionesComponent } from './component/modal-notificacion-comisiones/modal-notificacion-comisiones.component';
import { SeguimientoReferidosComponent } from './component/seguimiento-referidos/seguimiento-referidos.component';
import { ModalInformacionReferidoComponent } from './component/common/dialogs/modal-informacion-referido/modal-informacion-referido.component';
import { ModalBitacoraComponent } from './component/autorizaciones/modal-bitacora.component';
import { ModalReenvioComponent } from './component/autorizaciones/modal-reenvio-soportes.component';
import { ModalConfirReenvioComponent } from './component/autorizaciones/modal-confir-reenvio-soportes.component';
import { ModalCertificadosComponent } from './component/modal-certificados-poblacion/modal-certificados.component';
import { ModalValidarDocumentoComponent } from './component/modal-descarga-certificado/modal-validar-documento.component';
import { DescargasTokenComponent } from './component/descarga-reporte/descargas-token.component';
import { CertificadoRetencionComponent } from './component/certificado-retencion/certificado-retencion.component';
import { DialogMomentosWowComponent } from './component/common/dialogs/dialog-momentos-wow/dialog-momentos-wow.component';
// --- doc 7: traslados, auditoría, firmas ---
import { RadicacionTrasladosComponent } from './component/radicacion-traslados/radicacion-traslados.component';
import {
  NgbAccordionModule,
  NgbTooltipModule,
  NgbCollapseModule,
} from '@ng-bootstrap/ng-bootstrap';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ConfirmDialogComponent } from './component/common/dialogs/confirm-dialog/confirm-dialog.component';
import { InfoAlertComponent } from './component/info-alert/info-alert.component';
import { ContratoCardComponent } from './component/contrato-card/contrato-card.component';
import { TableNovedadTrasladosComponent } from './component/table-novedad-traslados/table-novedad-traslados.component';
import { ModalBasicComponent } from './component/common/dialogs/modal-basic/modal-basic.component';
import { HistoricoTrasladosComponent } from './component/historico-traslados/historico-traslados.component';
import { AlertMessageComponent } from './component/alert-message/alert-message.component';
import { CuestionarioSaludCardComponent } from './component/cuestionario-salud-card/cuestionario-salud-card.component';
import { TableComponent } from './component/common/table/table.component';
import { InterfazAuditoriaComponent } from './component/interfaz-auditoria/interfaz-auditoria.component';
import { TipoNovedadSelectorComponent } from './component/tipo-novedad-selector/tipo-novedad-selector.component';
import { SolicitudActivaModalComponent } from './component/solicitud-activa-modal/solicitud-activa-modal.component';
import { PreguntasSarlaftComponent } from './component/preguntas-sarlaft/preguntas-sarlaft.component';
import { CurrencyCopDirective } from '../app/shared/directives/currency-cop/currency-cop.directive';
import { AutorizacionRadicacionComponent } from './component/autorizacion-radicacion/autorizacion-radicacion.component';
import { SoporteDocumentosCardComponent } from './component/soporte-documentos-card/soporte-documentos-card.component';
import { ProgressBarComponent } from './component/progress-bar/progress-bar.component';
import { ContractoGeneradoComponent } from './component/contracto-generado/contracto-generado.component';
import { FirmasComponent } from './component/firmas/firmas.component';
import {
  RecaptchaModule,
  RECAPTCHA_SETTINGS,
  RecaptchaSettings,
} from 'ng-recaptcha';
import { URL_MAP } from './shared/urlMap';
import { ModalSeleccionProgramasComponent } from './component/cotizador/pages/contratante-page/components/modal-seleccion-programas/modal-seleccion-programas.component';
import { ModalValidacionUsuarioComponent } from './component/cotizador/pages/contratante-page/components/modal-validacion-usuario/modal-validacion-usuario.component';
import { PopUpConfirmacionComponent } from './component/cotizador/pages/contratante-page/components/pop-up-confirmacion/pop-up-confirmacion.component';
import { PopUpMensajeComponent } from './component/cotizador/pages/contratante-page/components/pop-up-mensaje/pop-up-mensaje.component';
import { ValidacionAreaCoberturaComponent } from './component/cotizador/pages/contratante-page/components/validacion-area-cobertura/validacion-area-cobertura.component';
import { ModalEnviarCotizacionComponent } from './component/cotizador/pages/cotizador-cotizacion-page/components/modal-enviar-cotizacion/modal-enviar-cotizacion.component';
import { FormularioContratanteComponent } from './component/cotizador/pages/contratante-page/components/formulario-contratante/formulario-contratante.component';
import { CotizadorCotizacionComponent } from './component/cotizador/pages/cotizador-cotizacion-page/components/cotizador-cotizacion/cotizador-cotizacion.component';
import { ModalDetalleCotizacionComponent } from './component/cotizador/pages/cotizador-cotizacion-page/components/modal-detalle-cotizacion/modal-detalle-cotizacion.component';
import { ResumenCotizacionProgramaComponent } from './component/cotizador/pages/cotizador-cotizacion-page/components/resumen-cotizacion-programa/resumen-cotizacion-programa.component';
import { DialogCerrarCotizacionComponent } from './component/common/dialogs/dialog-cerrar-cotizacion/dialog-cerrar-cotizacion.component';
import { DialogCuotaInscripcionComponent } from './component/common/dialogs/dialog-cuota-inscripcion/dialog-cuota-inscripcion.component';
import { DialogSeguimientoCotizacionComponent } from './component/common/dialogs/dialog-seguimiento-cotizacion/dialog-seguimiento-cotizacion.component';
import { NotificationDialogComponent } from './component/common/dialogs/notification-dialog/notification-dialog.component';
import { DialogForgetPasswordComponent } from './component/common/dialogs/dialog-forget-password/dialog-forget-password.component';
import { CotizadorSeguimientoComponent } from './component/cotizador-seguimiento/cotizador-seguimiento.component';
import { NotificacionesComponent } from './component/notificaciones/notificaciones.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    SidebarMenuComponent,
    PortafolioComponent,
    CarnetComponent,
    MaincontainerComponent,
    ForgetPasswordComponent,
    GenericDialogComponent,
    DialogGenericFrame,
    SafeUrlPipe,
    DialogCarnetSendComponent,
    DialogPoblacionDetalleComponent,
    DialogPoblacionDetalleAnexosComponent,
    DialogPoblacionGenerarComponent,
    CotizadorComponent,
    DialogBeneficiaryComponent,
    DialogContratComponent,
    DialogColectivoComponent,
    ModalAlert,
    MisCotizacionesComponent,
    MiCotizacionComponent,
    PoblacionComponent,
    ConsultaPoblacionComponent,
    CotizacionMultipleComponent,
    ComisionesComponent,
    FormularioSolicitudComponent,
    IframeGenericComponent,
    AfiliacionesComponent,
    ComisionesComponent,
    OportunidadesComercialesInternosComponent,
    DialogOportunidadesComponent,
    MisOportunidadesComercialesAsesorExternoComponent,
    OportunidadesRedirectComponent,
    AppTrackDirective,
    DialogOporunidadesExternosComponent,
    DetalleDialogComponent,
    GestionReferidosComponent,
    AutorizacionesComponent,
    MisReferidosComponent,
    ModalBitacoraComponent,
    ModalNotificacionComisionesComponent,
    SeguimientoReferidosComponent,
    ModalReenvioComponent,
    ModalConfirReenvioComponent,
    ModalCertificadosComponent,
    ModalValidarDocumentoComponent,
    DescargasTokenComponent,
    ModalInformacionReferidoComponent,
    DialogMomentosWowComponent,
    CertificadoRetencionComponent,
    // doc 7
    RadicacionTrasladosComponent,
    ConfirmDialogComponent,
    ContratoCardComponent,
    TableNovedadTrasladosComponent,
    ModalBasicComponent,
    HistoricoTrasladosComponent,
    AlertMessageComponent,
    CuestionarioSaludCardComponent,
    TableComponent,
    PreguntasSarlaftComponent,
    CurrencyCopDirective,
    AutorizacionRadicacionComponent,
    SoporteDocumentosCardComponent,
    InterfazAuditoriaComponent,
    ProgressBarComponent,
    ContractoGeneradoComponent,
    FirmasComponent,
    ModalSeleccionProgramasComponent,
    ModalValidacionUsuarioComponent,
    PopUpConfirmacionComponent,
    PopUpMensajeComponent,
    ValidacionAreaCoberturaComponent,
    ModalEnviarCotizacionComponent,
    FormularioContratanteComponent,
    CotizadorCotizacionComponent,
    ModalDetalleCotizacionComponent,
    ResumenCotizacionProgramaComponent,
    DialogCerrarCotizacionComponent,
    DialogCuotaInscripcionComponent,
    DialogSeguimientoCotizacionComponent,
    NotificationDialogComponent,
    DialogForgetPasswordComponent,
    CotizadorSeguimientoComponent,
    NotificacionesComponent,
  ],
  imports: [
    InfoAlertComponent,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatIconModule,
    MatCardModule,
    MatInputModule,
    MatSelectModule,
    MatSidenavModule,
    MatGridListModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatTreeModule,
    MatRadioModule,
    BrowserAnimationsModule,
    MatTableModule,
    MatDividerModule,
    DragScrollComponent,
    DragScrollItemDirective,
    CommonModule,
    MatTooltipModule,
    MatOptionModule,
    NgxSpinnerModule,
    MatDialogModule,
    MatTabsModule,
    MatNativeDateModule,
    MatButtonModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatButtonToggleModule,
    MatMenuModule,
    MatBadgeModule,
    MatListModule,
    MatPaginatorModule,
    MatSortModule,
    MatSnackBarModule,
    MatOption,
    MatProgressSpinnerModule,
    // doc 7
    NgbAccordionModule,
    NgbTooltipModule,
    NgbCollapseModule,
    QuillModule.forRoot(),
    TipoNovedadSelectorComponent,
    MatProgressBarModule,
    RecaptchaModule,
  ],
  exports: [],
  providers: [
    SessionStorageService,
    SnackBarService,
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: URL_MAP.API.RECAPTCHA_SITE_KEY,
      } as RecaptchaSettings,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TrackingInterceptor,
      multi: true,
    },
    {
      provide: MatPaginatorIntl,
      useValue: CustomPaginator(),
      useFactory: () => {
        const intl = new MatPaginatorIntl();
        intl.itemsPerPageLabel = 'Ítems por página:';
        intl.nextPageLabel = 'Página siguiente';
        intl.previousPageLabel = 'Página anterior';
        intl.firstPageLabel = 'Primera página';
        intl.lastPageLabel = 'Última página';
        intl.getRangeLabel = (page, pageSize, length) => {
          if (length === 0) return '0 de 0';
          const start = page * pageSize + 1;
          const end = Math.min((page + 1) * pageSize, length);
          return `${start} – ${end} de ${length}`;
        };
        return intl;
      },
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
  ) {
    //header icons
    this.matIconRegistry.addSvgIcon(
      'menu_icon',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/menu.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'home_icon',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/home.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'logout_icon',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/logout.svg',
      ),
    );
    //login icons
    this.matIconRegistry.addSvgIcon(
      'eye',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/eye.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'eye_off',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/eye_off.svg',
      ),
    );
    //menu icons
    this.matIconRegistry.addSvgIcon(
      'carnet',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/carnet.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'comisiones',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/comisiones.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'cotizador',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/cotizador.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'gestion',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/gestion.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'poblacion',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/poblacion.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'portafolio',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/portafolio.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'link_pagos',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/imagenes/svg/link_pagos.svg')
    );
    //portafolio icons
    this.matIconRegistry.addSvgIcon(
      'favorite_on',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/favorite_on.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'favorite_off',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/favorite_off.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'document',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/document.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'video',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/video.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'image',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/image.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'pdf',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/pdf.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'download',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/download.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'share',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/share.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'whats',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/whats.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'poblacion_search',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/poblacion_search.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'poblacion_bill',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/poblacion_bill.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'poblacion_carnet',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/poblacion_carnet.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'poblacion_directorio',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/poblacion_directorio.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'poblacion_doc',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/poblacion_doc.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'poblacion_link',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/poblacion_link.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'poblacion_person',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/poblacion_person.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'poblacion_tel',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/poblacion_tel.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'afiliaciones',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/imagenes/svg/afiliaciones.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'poblacion_reside',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/imagenes/svg/poblacion_reside.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'plus',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/imagenes/svg/plus.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'oportunidad2',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/oportunidad2.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'notifications_icon',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/bell-330.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'referidos_icon',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/organigrama.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'autorizaciones',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/autorizaciones.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'info_icon',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/info_icon.svg'
      )
    )
    this.matIconRegistry.addSvgIcon(
      'certificados',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/imagenes/svg/certificados.svg'
      )
    );
  }
}
